import { createContext } from 'react';

export const LanguageContext = createContext(null);
export const LanguageContextProvider = LanguageContext.Provider;
